import { Component, OnInit, HostListener } from '@angular/core';
import { BreadcrumbService } from 'global/services/breadcrumb/breadcrumb.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { map, merge, filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Location } from '@angular/common';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {

    private breadcrumb;
    private breadcrumbSubscription;

  constructor(
  	private breadcrumbService : BreadcrumbService, 
  	private router : Router,
  	private route : ActivatedRoute, 
  	private location : Location
	) { }

  ngOnInit() {
    this.breadcrumbSubscription = this.breadcrumbService.breadcrumb.subscribe( _breadcrumb => {
        this.breadcrumb = _breadcrumb;
    });
  }

  /**
  * @param breadcrumbItem : {label : string, route : string}
  * Navigate to the specified route, and update the breadcrumb accordingly
  */
  navigate(breadcrumbItem : any, index : number){
      if(index == this.breadcrumb.length -2){
          this.breadcrumbService.removeLast();
          index == 0 ? this.router.navigate([breadcrumbItem.route]) : this.location.back();
      }
      else if(index < this.breadcrumb.length - 1){
          this.breadcrumbService.removeFrom(index);
          // this.location.replaceState(breadcrumbItem.route);
          this.router.navigate([breadcrumbItem.route]);
      }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    sessionStorage.setItem('tmpBreadcrumb',JSON.stringify(this.breadcrumb));
  }

  ngOnDestroy(){
    this.breadcrumbSubscription.unsubscribe();
  }

}